export const OrganizationDeregistration = (
    <div className="flex flex-col gap-2">
        <div>
            This exhibit lists lobby-firm registrations that were
            de-registered and not renewed over the last 12 months.
        </div>
    </div>
);
